import React, { useEffect } from 'react';
import useApp from 'hooks/useApp'
import { Button } from 'components'
import styles from './index.module.css'

const DataDetailNone = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className={`${styles["count-group"]} padding`}>
				<p>개인신용정보 목록 선택</p>
				<div><span>1</span>/3</div>
			</div>
			<div className="center-cont">
				<i className="icon icon_no_data" />
				<p className="mt_20">전송요구 가능한<br />정보제공기관이 없습니다.</p>
			</div>
			<div className="flex-shrink_0 padding btn-group">
				<Button className="btn btn--big btn--gray">메인으로 가기</Button>
				<Button className="btn btn--big ml_10">재시도</Button>
			</div>
		</div>
	)
}

export default DataDetailNone